module.exports = __webpack_public_path__ + "static/media/wechatQrcodeFFF.6256d54a.png";